import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "../../../axios";
import BankAccountForm from "./BankAccountForm";

export default function BankAccountCreatePage() {
    const [form, setForm] = useState({
        bank_name: "",
        account_name: "",
        account_number: "",
    });



    const navigate = useNavigate();
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        try {
            await axios.post("/admin/bank-accounts", form);
            navigate("/admin/bank-accounts");
        } catch (err) {
            setError("Gagal menyimpan data. Pastikan input valid.");
        }
    };

    return (
        <div className="card mt-4">
            <div className="card-header border-bottom">
                <Link to="/admin/bank-accounts" className="mt-3">Kembali</Link>
                <h4 className="mb-0">Tambah Rekening Bank</h4>
            </div>
            <div className="card-body">
                {error && <div className="alert alert-danger">{error}</div>}
                <BankAccountForm form={form} setForm={setForm} onSubmit={handleSubmit} />
                
            </div>
        </div>
    );
}
